<template>
  <div class="layout reg_wrap">
      <div class="avatar">  
        <img :src="userForm1.avatarUrl" @click="setImg" v-load="'oAvatar'">
        <p>点击更换头像</p>
      </div>
      <van-form  @submit="onSubmit" class="reg_user_form" scroll-to-error error-message-align="right" input-align="right">
        <van-field
          v-model="userForm1.nickName"
          name="nickName"
          label="昵称"
          placeholder="请输入昵称"
          
          :rules="[{ required: true, message: '请填写昵称' }]"
        />
        <van-field
          v-model="userForm1.phone"
          name="phone"
          type="digit"
          label="手机"
          placeholder="请输入手机号"
          :rules="[{required:true,validator:validatorPhone, message: '请输入正确手机号' }]"
        />
        <van-field
          v-model="userForm1.code"
          type="digit"
          name="code"
          label="验证码"
          :rules="[{required:false,message:'请输入验证码'}]"
        >
         <template #button>
          <span class="send_code" v-if="timer" style="color:#999;">{{ count || 0}}s</span>
          <span @click="send" class="send_code"   v-else>发送验证码</span>
         </template>
        </van-field>
        <van-field
          readonly
          clickable
          is-link
          name="title"
          :value="userForm1.title"
          label="称谓"
          placeholder="请选择"
          @click="showJob= true"
        />
          <van-popup v-model="showJob" position="bottom">
            <van-picker
              show-toolbar
              :columns="appellList"
              @confirm="onJob"
              @cancel="showJob = false"
            />
          </van-popup>
        <van-field
          readonly
          clickable
          name="birthday"
          is-link
          :value="userForm1.birthday"
          label="出生年份"
          placeholder="请选择"
          @click="showDateBirth = true"
        />
        <van-popup v-model="showDateBirth" position="bottom">
          <van-datetime-picker
            v-model="dateVal"
            type="date"
            title="选择出生日期"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="onDateBirth"
            @cancel="showDateBirth = false"
          />
        </van-popup>
         <p>个人简介</p>
        <van-field
          class="input_brief"
          name="introduction"
          v-model="userForm1.introduction"
          type="textarea"
          input-align="left"
          placeholder="请简要介绍一下自己~"
          maxlength="200"
          show-word-limit
        />
<!--            -->
        <div class="auth_btn"  @click="AuthShow" :class="authShow?'ok':''">{{authShow?'取消认证':'认证成为专业买家，解锁更多权限'}}</div>
        <div class="auth_form" v-if="authShow">
          <van-field
            v-model="userForm1.name"
            name="name"
            label="姓名"
            placeholder="请输入"
            :rules="[{ required: true, message: '请填写姓名' }]"
          />
          <van-field v-model="userForm1.company" name="company" label="公司" placeholder="请输入"  maxlength="20" />
          <van-field v-model="userForm1.department" name="department" label="部门" placeholder="请输入" maxlength="10"/>
          <van-field v-model="userForm1.jobTitle" name="jobTitle" label="职务" placeholder="请输入" maxlength="7" />
          <van-field
            readonly
            clickable
            name="city"
            :value="userForm1.city"
            right-icon="arrow"
            label="城市"
            placeholder="请选择"
            @click="showArea = true"
            :rules="[{ required: true, message: '请选择城市' }]"
          />
          <van-popup v-model="showArea" position="bottom">
            <van-area
              :area-list="areaList"
              @confirm="onCity"
              @cancel="showArea = false"
              :columns-placeholder="['请选择', '请选择', '请选择']"
            />
          </van-popup>
          <van-field v-model="userForm1.address" name="address" label="详细地址" placeholder="请输入" :rules="[{ required: true, message: '请输入详细地址 ' }]" />
          <!-- <van-field
            readonly
            clickable
            name="care"
            :value="userForm.care"
            right-icon="arrow"
            label="感兴趣的类别"
            placeholder="请选择"
            @click="showCare = true"
          /> -->
          <div class="van-cell" name="care" @click="regCareShow">
            <div class="van-cell__title"><span>感兴趣的类别</span></div>
            <div class="van-cell__value">
              <div class="van-field__body">
                <div class="van-field__control van-field__control--right care_input">{{userForm1.category.length>0?'已选择':'请选择'}}<span v-if="userForm1.category.length>0">{{categoryNum}}</span>{{categoryNum>0?'个':''}}</div>
                <div class="van-field__right-icon">
                  <van-icon name="arrow" />
                </div>
              </div>
            </div>
          </div>
          <div class="care_uploading">
            <div class="uploading_wrap" @click="uploadOk" v-if="!userForm1.businessCard">
              <i class="van-icon van-icon-plus van-uploader__upload-icon"></i>
              <span>上传名片</span>
            </div>
            <div class="uploading_ok" v-if="userForm1.businessCard">
              <i @click="userForm1.businessCard=''" class="van-icon van-icon-clear van-uploader__preview-delete"></i>
              <img :src="userForm1.businessCard">
            </div>
          </div>
          <!-- <van-uploader class="care_uploading" v-model="cardList" upload-text="上传名片" :after-read="uploadOk" :before-delete="upadDelete" :max-count="1"  upload-icon="plus"/> -->
        </div>
        <van-button class="sumbit_btn" color="#f85b0f" block type="info" native-type="submit">提交</van-button>
      </van-form>
      <reg-care @careCheck="careUpData" ref="regCare" v-bind:list="categoryList1"></reg-care>
  </div>
</template>
<script>
import moment from "moment"
import { mapActions, mapGetters, mapMutations } from "vuex";
import regCare from "@components/reg-care";
import provincial from '@/assets/js/provincial.json';     //省市区json
export default {
  name: "registry",
  components:{
    regCare
  },
  data() {
    return {
      userForm1:{
        inMemberId: "",
        exhibitionId: "",
        exhibitorId: "",
        userRole: 0,
        category: "",
        business: "",
        auditState: 0,
        auditUser: "",
        auditTime: "",
        auditRemark: "",
        userId: "",
        nickName: "",
        name: "",
        phone: "",
        phoneConfirm: "",
        avatarUrl: "",
        jobTitle: "",
        company: "",
        department: "",
        country: "",
        province: "",
        city: "",
        county: "",
        address: "",
        birthday: "",
        title: "",
        introduction: "",
        businessCard: "",
        id: "",
        deleteAt: "",
        isDeleted: false,
        createAt: "",
        updateAt: ""
      },
      authShow:false,  //认证信息是否显示
      showJob:false,  //称谓选择框
      showDateBirth:false,  //出生日期选择框
      maxDate:new Date(),
      dateVal:new Date(),
      minDate:new Date(1940, 0, 1),
      appellList:['先生','小姐','女士'],
      count:0,
      timer:null,
      //认证信息相关
      cityCode:'',  //省市区编号，默认
      showArea: false, //城市选择弹出框
      cardList:[],    //名片
      careList:[],   //感兴趣类别数组
      areaList: {},
      categoryNum:'', //感兴趣的个数
      codeKey:'',
      newlist:'', //感兴趣类型的数组
      categoryList:[],
      categoryList1:[], //感兴趣类型的选中id数组
      userRole:'',
      avatarUrl:''//头像
    } 
  },
  created(){
    this.authShow=this.$route.query.isauthShow==1?true:false;
    this.areaList=provincial;
    this.init()
  },
  mounted(){
  },
  computed: {
    ...mapGetters({
      exhibitionId:'getExhibitionId',
      inMemberId:'getInMemberId',
      userInfo:'getUserInfo'
    }),
  },
  methods:{
    ...mapActions({ 
      sendCode: "login/sendCode",
      validateCode: "login/validateCode",
      getMemberCurrent:'login/getMemberCurrent',
      editUser:'login/editUser',
      memberUpdate:'login/memberUpdate',
      editUserRole:'login/editUserRole',
      getUser:'login/getUser',
      wxUpLoadImg:'upload/wxUpLoadImg',
      toprofessionalbuyer:'login/toprofessionalbuyer',
      registryUser:'login/registryUser'
    }),
    async init(){
      await this.$Myapollo.getUserInfo(this);
      console.log(this.userInfo,'this.userInfo')
        // this.introduction = data.introduction
      this.userForm1 = this.userInfo;
      // this.avatarUrl =data.avatarUrl

      this.userForm1.name = ''
      this.userForm1.introduction=this.userForm1.introduction?this.userForm1.introduction:'';
      // this.userForm1.nickName=this.userForm1.nickName?this.userForm1.nickName:this.userForm1.name;
      if (this.userForm1.category != null&&this.userForm1.category!=''){
        console.log(this.userForm1.category)  
        let a=JSON.parse(this.userForm1.category) //把返回的兴趣类型字符串转json
        for (let i=0;i<a.length;i++){
          console.log(a[i].Lists)
          this.categoryList = [...this.categoryList,...a[i].Lists]
        }
        this.categoryNum =this.categoryList.length // 获取感兴趣类型的个数
        for (let j=0;j<this.categoryList.length;j++){
          this.categoryList1.push(this.categoryList[j].Id)
        }

      }else {
        this.userForm1.category = []
      }
    },
    AuthShow(){
      if(this.authShow == false){
        this.authShow = true
      }else{
        this.authShow = false
      }

    },
    //手机号校验
    validatorPhone(val){
      return /^1[3456789]\d{9}$/.test(val);
    },
    //表单提交
   async  onSubmit(values){
     console.log(this.userForm1.code)
      let res = await this.validateCode({
        key:this.codeKey,
        code: this.userForm1.code
      });
      if(res){
        console.log(this.userForm1.id)
        if(this.authShow == false){
          // values.company = ''
          // values.name = ''
          // values.department = ''
          // values.jobTitle = ''
          // values.address = ''
          // values.city = ''
          // values.category = ''

          values.avatarUrl = this.userForm1.avatarUrl
          values.inMemberId = this.inMemberId
          console.log(values,'普通用户注册')
          let res =await this.registryUser(values)// 注册普通买家或修改个人信息
          console.log(res)
          if (res.result == true){
            this.$toast.success('注册成功');
            this.count= 0;
            this.getUser()
            this.$router.go(-1);
            // this.userRole = 1
            // let useres = await this.editUserRole({userRole:this.userRole}) //更改用户状态
            // console.log(useres)
            // if(useres.result == true){
            //   console.log(useres.result)
            //
            // }
          }
      else{
            this.$toast.fail(res.message);
          }
        }
        else {
          if(this.categoryNum ==0||''){
            this.$toast.fail('请选择感兴趣的类别')
            return
          }
          if (!this.userForm1.businessCard){
            this.$toast.fail('请上传个名片')
            return
          }
          if((/.*1[3|4|5|7|8][0-9]{9}.*/.test(this.userForm1.introduction))){
            this.$toast.fail('请勿输入手机号')
            return;
          }
          let city1 = this.userForm1.city.split("/") //将城市转化为一个数组
          console.log(city1[0])
          console.log(city1[1])
          console.log(city1[2])
          if (city1[0] != undefined){
            this.userForm1.province = city1[0]
          }
          if (city1[1] != undefined){
            this.userForm1.city = city1[1]
          }
          if (city1[2] != undefined){
            this.userForm1.county = city1[2]
          }
          if (this.userForm1.category.length > 0 && this.newlist.length>0){
            let category1 = JSON.stringify(this.newlist) //将感兴趣的类别转化为字符串
            this.userForm1.category = category1
          }
          else if(this.newlist.length ==0 &&this.userForm1.category.length ==0){
            this.userForm1.category = ''
          }
          this.userForm1.name = values.name
          this.userForm1.company = values.company
          this.userForm1.department = values.department
          this.userForm1.jobTitle = values.jobTitle
          this.userForm1.address = values.address
          this.userForm1.inMemberId = this.inMemberId
          this.userForm1.nickName = values.nickName
          this.userForm1.phone = values.phone
          this.userForm1.birthday = values.birthday
          this.userForm1.title = values.title
          this.userForm1.introduction = values.introduction

          let res =await this.toprofessionalbuyer(this.userForm1)
          if(res.result == true) {
            this.$toast.success('提交认证成功，等待后台审核');
            this.getUser()
            this.$router.go(-1);
          }
            // if(res.result == true){
              // this.userRole = 2
              // let useres = await this.editUserRole({userRole:this.userRole}) //更改用户状态
              // if(useres.result == true){
              //
              // }
              // else{
              //   this.$toast.fail('认证失败');
              // }
            //
            // }else{
            //   this.$toast.fail('认证失败');
            // }
          // }
          else{
            this.$toast.fail('认证失败');
          }


        }

      }else{
        console.log("验证码错误")
        this.$toast.fail({
          message:'验证码有误',
          closeOnClick :true
        });
      }
    },
    //发送验证码
    async send(){
      console.log(this.userForm1.phone)
      if(!this.validatorPhone(this.userForm1.phone))
      {
        return 
      }
      this.$toast.loading({
        message: '发送中...',
        forbidClick: true,
      });
      this.downTime();
      let res = await this.sendCode({
        PhoneNumber: this.userForm1.phone
      });
      if (res && res.result) {
        console.log(res.data.key)
        this.codeKey=res.data.key;
        this.$toast.success('已发送');
      } else {
        this.$toast.fail("发送失败！");
      }
    },
    //倒计时
    downTime() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        const timer = setInterval(() => {
          let count = this.count;
          if (count > 0 && count <= TIME_COUNT) {
            count--;
            this.count = count;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
        this.timer = timer;
      }
    },
    //称谓选择
    onJob(val){
      this.userForm1.title=val;
      this.showJob=false;
    },
    //出生日期选择
    onDateBirth(date){
      this.userForm1.birthday=moment(date).format("YYYY-MM-DD");
      this.showDateBirth=false;
    },
    //更换头像
    updateImg(file){
      this.userForm1.imgUrl=file.content;
    },

    //认证信息相关
    //城市选择确认
    onCity(values) {
      let cityarr=[];
      values.map((item)=>{
        if(item&&item.name!=''){
          cityarr.push(item.name)
        }
        else{
          return 
        }
        });
      this.userForm1.city=cityarr.join('/');
      this.showArea=false;
    },
    
    async uploadOk() {  // 上传名片
      const that = this; 
      const callBack = (data) => { 
        console.log('名片coverImg', data);
      };
      const img = await this.wxUpLoadImg(callBack); 
      console.log('上传的名片：', img);
      if(img){
        this.userForm1.businessCard = img;
      }
      else
      {
        this.$toast.fail('上传失败');
      }
    },
    //删除名片前
    upadDelete(file){
      this.userForm1.care='';
      return true
    },
    //点击感兴趣选择
    regCareShow(){
      this.$refs['regCare'].open();
    },
     //感兴趣数据更新
    careUpData(vals,newlist){
      console.log(vals.length)
      console.log(newlist)
      this.categoryList1 = vals
      this.newlist = newlist
      this.categoryNum = vals.length
      this.userForm1.category=vals;
    },

    async setImg() {  // 设置云名片图片
      const that = this;
      const callBack = (data) => {
        console.log('coverImg编辑个人资料', data);
      };
      const img = await this.wxUpLoadImg(callBack);
      console.log('编辑头像上传的图片：', img);
      if(img){
        this.userForm1.avatarUrl = img;
        // this.onSubmit('avatarUrl',this.userForm1.avatarUrl);
      }else{
        this.$toast.fail({
          message:'上传头像失败',
          closeOnClick :true
        });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.reg_wrap{
    background: #131825;
    padding:0 0.24rem 0.98rem;
    .avatar{
      padding-top: 0.5rem;
      padding-bottom: 0.39rem;
      border-bottom: 1px solid #1d2435;
      display: flex;
      flex-direction: column;
      align-items: center;
      img{
        height: 1.4rem;
        width: 1.4rem;
        border-radius: 50%;
        // object-fit: cover;
        border: 2px solid #fff;
      }
      p{
        color: #fff;
        line-height: 1;
        margin-top: 0.2rem;
      }
    }
    .reg_user_form{
      &::v-deep .van-cell{
        background: transparent;
        color: #fff;
        padding:0.3rem 0;
        border-bottom: 1px solid #1d2435;
        font-size: 0.3rem;
        &.input_brief{
          border-bottom:none;
          padding:0.2rem;
          background: #1d2435;
          border-radius: 0.03rem;
          height: 1.9rem;
          .van-cell__value{ 
            .van-field__body{
              .van-field__word-limit{
                font-size: 0.24rem;
              }
              .van-field__control{
                font-size: 0.24rem;
                line-height: 0.28rem;
              }
            }
          }
        }
        &::after{
          display: none;
        }
        .van-cell__value{ 
          .van-field__body{
            .van-field__control{
              font-size: 0.3rem;
              color: #bfbfbf;
              &.care_input{
                span{
                  font-size: 0.3rem;
                  color: #f85b0f;
                  text-overflow:ellipsis; overflow:hidden;
                  margin: 0 0.05rem 0 0.08rem;
                }
              }
            }
            .send_code{
              font-size: 0.3rem;
              color: #f85b0f;
            }
            .van-field__right-icon{
              padding: 0 0.2rem 0 0;
              i{
                font-size: 0.24rem;
              }
            }
          }
          .van-field__error-message{
            position: absolute;
            right: 0;
            top:0.35rem;
          }
        }
        .van-cell__title{
          span{
            font-size: 0.3rem;
          }
        }
      }
      >p{
        font-size: 0.3rem;
        color: #fff;
        line-height: 1;
        padding: 0.35rem 0 0.2rem;
      }
      .sumbit_btn{
        font-size: 0.36rem;
        height: 0.98rem;
        line-height: 0.98rem;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        border-radius: 0;
        span{
          font-size: 0.36rem;
        }
      }
      .auth_btn{
        margin-top: 0.9rem;
        padding-bottom: 0.4rem;
        text-align: center;
        line-height: 1;
        font-size: 0.3rem;
        color: #f85b0f;
        &.ok{
          border-bottom: 1px solid #1d2435;
        }
      }
      .auth_form{
        .care_uploading{
          margin: 0.5rem auto;
          display: block;
          width: 6rem;
          height: 3.35rem;
          background: #1d2435;
          .uploading_wrap{
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            color: #fff;
            i{
              display: inline-block;
              font-size: 0.64rem;
              color: #fff;
            }
            span{
              margin-top: 0.16rem;
              color: #fff;
              font-size: 0.3rem;
            }
          }
          .uploading_ok{
            width: 100%;
            height: 100%;
            position: relative;
            img{
              // object-fit: cover;
              display: block;
              width: 100%;
              height: 100%;
            }
            i{
              // color: transparent;
              // background: #fff;
            }
          }
        }
      }
  }
}
</style>
